/* esm.sh - kapsule@1.16.3 */
export * from "/*kapsule@1.16.3/esnext/kapsule.mjs";
export { default } from "/*kapsule@1.16.3/esnext/kapsule.mjs";
